import util from '@bmp-vue/core/api/util'
const controller = 'Lojadomecanico'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  SavePropostaCampoAuxiliar (th) {
    const campos = []

    if ([null, undefined].indexOf(th.model.ObservacaoVendedor) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_OBSERVACAOVENDEDOR', ValorCampo: th.model.ObservacaoVendedor }) }

    if (campos.length > 0) { th.$api.Multiplo.SavePropostaCampoAuxiliar({ dto: campos }) }
  },
  async CarregaDados (th, documento) {
    const obj = await th.$api.Multiplo.CarregaDadosPessoa(documento)
    if (obj) {
      th.$set(th.model.Pessoa, 'DocumentoFederal', documento)
      th.$set(th.model.Pessoa, 'Codigo', obj.Codigo)
      th.$set(th.model.Pessoa, 'Nome', obj.Nome);
      th.$set(th.model.Pessoa, 'PJ', obj.PJ);
      if (obj.PessoaDadosContato) {
        th.$set(th.model.Pessoa.PessoaDadosContato, 'Email', obj.PessoaDadosContato.Email)
        th.$set(th.model.Pessoa.PessoaDadosContato, 'TelefoneCelular1', th.$api.UI.Format.Celular(obj.PessoaDadosContato.TelefoneCelular1))
        th.$set(th.model.Pessoa.PessoaDadosContato, 'TelefoneFixo1', obj.PessoaDadosContato.TelefoneFixo1 ? th.$api.UI.Format.Telefone(obj.PessoaDadosContato.TelefoneFixo1) : '')
      }
      if (obj.PessoaDadosEndereco) {
        th.$api.UTIL.Functions.SetAllButNull(th, th.model.Pessoa, 'PessoaEndereco', obj.PessoaDadosEndereco)
      }
    } else {
      th.$set(th.model, 'Pessoa', {
        ...th.model.Pessoa,
        DocumentoFederal: documento,
        PF: {},
        PJ: {},
        PessoaDadosContato: {},
        PessoaBanco: {},
        PessoaEndereco: {},
      })
    }
  }
})
